module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_sac_m_en.6268d57e6f341454aea8b67b19782ed4.png";